

// import React, { useRef, useState, useEffect,useMemo } from "react";
// import {
//   GoogleMap,
//   StandaloneSearchBox,
//   useJsApiLoader,
//   Polygon,
// } from "@react-google-maps/api";
// import Pin from "../../../assets/imgs/icons/pin.png"; // Marker image path
// import { createPortal } from "react-dom";

// import { useDispatch, useSelector } from "react-redux";
// import {
//   clearPickupLocation,
//   setPickupLocation,
// } from "../../../redux/slices/pickupLocationSlice";

// const containerStyle = {
//   width: "100%",
//   height: "400px",
// };

// const libraries = ["places", "geometry"];

// const PickupMap = ({
//   API_KEY,
//   setShowPickupMap,
//   polygonCoordinates,
//   setIsOpen,
// }) => {
//   const dispatch = useDispatch();

//   // Access pickup location from Redux
//   const pickupLocation = useSelector((state) => state.pickupLocation);

//   const pickupRef = useRef(null);
//   const pickupMapRef = useRef(null);
//   const inputRef = useRef(null); 

//   const [mapCenter, setMapCenter] = useState({
//     lat: 15.273817622105538,
//     lng: 76.39305350184958,
//   });
//   const [outOfBounds, setOutOfBounds] = useState(false);

//   const { isLoaded } = useJsApiLoader({
//     googleMapsApiKey: API_KEY,
//     libraries,
//   });

//   // useEffect(() => {
//   //   if (inputRef.current) {
//   //     inputRef.current.focus();
//   //   }
//   // }, [inputRef]); 

  

// console.log("polygonCoordinates", polygonCoordinates);
  

//   // console.log("polygonCoordinates", polygonCoordinates);



//   // ✅ Convert polyCoordinates to Google Maps format
//   const polygonPath =
//     Array.isArray(polygonCoordinates) && polygonCoordinates.length > 0
//       ? polygonCoordinates[0].map((coord) => ({
//           lat: coord.latitude,
//           lng: coord.longitude,
//         }))
//       : [];

//   // ✅ Create bounds from polygon coordinates
//   // const bounds = new window.google.maps.LatLngBounds();
//   // polygonPath.forEach((point) => {
//   //   bounds.extend(new window.google.maps.LatLng(point.lat, point.lng));
//   // });

//   const bounds = useMemo(() => {
//     if (!isLoaded || !window.google?.maps) return null;
  
//     const b = new window.google.maps.LatLngBounds();
//     polygonPath.forEach((point) => {
//       b.extend(new window.google.maps.LatLng(point.lat, point.lng));
//     });
//     return b;
//   }, [isLoaded, polygonPath]);
  

//   // ✅ Function to check if the marker is within the polygon
//   const isWithinPolygon = (lat, lng) => {
//     if (!window.google || !window.google.maps || !window.google.maps.geometry) {
//       console.error("Google Maps Geometry library is not loaded.");
//       return false;
//     }

//     const point = new window.google.maps.LatLng(lat, lng);
//     const polygon = new window.google.maps.Polygon({ paths: polygonPath });

//     return window.google.maps.geometry.poly.containsLocation(point, polygon);
//   };

//   // ✅ Reverse Geocode Function
//   // const reverseGeocode = (lat, lng) => {
//   //   const geocoder = new window.google.maps.Geocoder();
//   //   const location = { lat, lng };

//   //   geocoder.geocode({ location }, (results, status) => {
//   //     if (status === "OK" && results[0]) {
//   //       const address = results[0].formatted_address;

//   //       // ✅ Dispatch to Redux store
//   //       dispatch(
//   //         setPickupLocation({
//   //           latitude: lat,
//   //           longitude: lng,
//   //           title: address,
//   //           subtext: "",
//   //           place_id: results[0].place_id || "",
//   //         })
//   //       );

//   //       // ✅ Check if the marker is within the polygon
//   //       setOutOfBounds(!isWithinPolygon(lat, lng));
//   //     } else {
//   //       console.error("Geocode failed:", status);
//   //     }
//   //   });
//   // };

//   const reverseGeocode = (lat, lng) => {
//   if (!window.google || !window.google.maps?.Geocoder) {
//     console.error("Google Maps Geocoder not available");
//     return;
//   }

//   const geocoder = new window.google.maps.Geocoder();
//   const location = { lat, lng };

//   geocoder.geocode({ location }, (results, status) => {
//     if (status === "OK" && results[0]) {
//       const address = results[0].formatted_address;
//       dispatch(
//         setPickupLocation({
//           latitude: lat,
//           longitude: lng,
//           title: address,
//           subtext: "",
//           place_id: results[0].place_id || "",
//         })
//       );
//       setOutOfBounds(!isWithinPolygon(lat, lng));
//     } else {
//       console.error("Geocode failed:", status);
//     }
//   });
// };


//   const handlePlaceChange = () => {
//     const places = pickupRef.current.getPlaces();
//     if (places && places.length > 0) {
//       const place = places[0];
//       const location = place.geometry.location;
//       const lat = location.lat();
//       const lng = location.lng();

//       if (pickupMapRef.current) {
//         pickupMapRef.current.panTo({ lat, lng });
//         pickupMapRef.current.setZoom(18);
//       }

//       setMapCenter({ lat, lng });

//       // ✅ Dispatch Redux action instead of local state
//       dispatch(
//         setPickupLocation({
//           latitude: lat,
//           longitude: lng,
//           title: place.formatted_address || "",
//           subtext: "",
//           place_id: place.place_id || "",
//         })
//       );

//       // ✅ Check polygon bounds
//       setOutOfBounds(!isWithinPolygon(lat, lng));
//     }
//   };

//   const handleMapDragEnd = () => {
//     if (pickupMapRef.current) {
//       const newCenter = pickupMapRef.current.getCenter();
//       const newLat = newCenter.lat();
//       const newLng = newCenter.lng();

//       setMapCenter({ lat: newLat, lng: newLng });

//       // ✅ Reverse geocode and check polygon
//       reverseGeocode(newLat, newLng);
//     }
//   };

//   const clearSearch = () => {
//     dispatch(clearPickupLocation());
//   };

//   const SearchBoxWithPortal = ({ children }) => {
//     return createPortal(children, document.body);
//   };

//   const handleSearchBoxLoad = (ref) => {
//     pickupRef.current = ref;
  
//     // Use a delay to ensure focus works
//     setTimeout(() => {
//       if (inputRef.current) {
//         inputRef.current.focus();
//       }
//     }, 300);
//   };

//   useEffect(() => {
//     // Focus the input
//     if (inputRef.current) {
//       inputRef.current.focus();
//     }
  
//     // Get current location on first load
//     if (navigator.geolocation) {
//       navigator.geolocation.getCurrentPosition(
//         (position) => {
//           const lat = position.coords.latitude;
//           const lng = position.coords.longitude;
  
//           setMapCenter({ lat, lng });
  
//           // Pan the map to current location
//           if (pickupMapRef.current) {
//             pickupMapRef.current.panTo({ lat, lng });
//             pickupMapRef.current.setZoom(16);
//           }
  
//           // Reverse geocode and dispatch
//           reverseGeocode(lat, lng);
//         },
//         (error) => {
//           console.error("Error getting location:", error);
//         },
//         {
//           enableHighAccuracy: true,
//           timeout: 10000,
//           maximumAge: 0,
//         }
//       );
//     } else {
//       console.warn("Geolocation is not supported by this browser.");
//     }
//   }, []);

  
//   if (!isLoaded) {
//     return <p>Loading map...</p>;
//   }


//   return (
//     <div
//        style={{ 
//         position: "fixed",
//         top: 0,
//         left: 0,
//         right: 0,
//         bottom: 0,
//         backgroundColor: "rgba(0, 0, 0, 0.5)",
//         zIndex: 9999,
//         display: "flex",
//         justifyContent: "center",
//         alignItems: "center",
//         marginTop: "80px"
//       }}
//       // className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
//     >
//       <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-2/3 relative">
//         {/* Search Box */}
//         <StandaloneSearchBox
//           onLoad={handleSearchBoxLoad} 
//           onPlacesChanged={handlePlaceChange}
//           options={{
//             ...(bounds ? { bounds } : {}),
//             componentRestrictions: { country: "IN" },
//           }}
//         >
//           <div className="relative">
//             <input
//             ref={inputRef}
//               type="text"
//               placeholder="Pickup Location"
//               value={pickupLocation?.title || ""}
//               onChange={(e) =>
//                 dispatch(
//                   setPickupLocation({
//                     ...pickupLocation,
//                     title: e.target.value,
//                   })
//                 )
//               }
//               className="w-full p-2 border rounded mb-3 cursor-pointer pr-10"
//             />

//             {/* ✅ Clear Button */}
//             {pickupLocation.title && (
//               <button
//                 onClick={clearSearch}
//                 className="absolute right-3 top-2 text-gray-500 hover:text-red-500"
//               >
//                 ❌
//               </button>
//             )}
//           </div>
//         </StandaloneSearchBox>

//         {/* Map */}
//         <div className="relative">
//           <GoogleMap
//             mapContainerStyle={containerStyle}
//             center={mapCenter}
//             zoom={13}
//             onLoad={(map) => (pickupMapRef.current = map)}
//             onDragEnd={handleMapDragEnd}
//             options={{
//               disableDefaultUI: true,
//               zoomControl: true,
//               mapTypeControl: false,
//               fullscreenControl: false,
//               streetViewControl: false,
//             }}
//           >
//             {/* Render Polygon */}
//             <Polygon
//               paths={polygonPath}
//               options={{
//                 fillColor: "transparent",
//                 fillOpacity: 0.4,
//                 strokeColor: "light black",
//                 strokeOpacity: 0.5,
//                 strokeWeight: 1,
//               }}
//             />
//           </GoogleMap>

//           {/* Marker */}
//           <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
//             <img src={Pin} alt="Marker" className="w-10 h-10" />
//           </div>

//           {/* Out of bounds message */}
//           {outOfBounds && (
//             <div className="absolute top-5 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg z-10">
//               🚫 We are not serving this area.
//             </div>
//           )}
//         </div>

//         {/* Buttons */}
//         <div className="flex justify-between gap-4 mt-3">
//           <button
//             className="w-1/2 py-2 bg-white text-red-500 rounded-lg hover:bg-red-200"
//             onClick={() => {
//               setShowPickupMap(false);
//               dispatch(clearPickupLocation());
//             }}
//           >
//             Cancel
//           </button>
//           <button
//             className={`w-1/2 py-2 rounded-lg ${
//               outOfBounds
//                 ? "bg-gray-400 cursor-not-allowed"
//                 : "bg-black text-white"
//             }`}
//             onClick={() => {
//               setShowPickupMap(false);
//               setIsOpen(true);
//             }}
//             disabled={outOfBounds}
//           >
//             Confirm
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PickupMap;




import React, { useRef, useState, useEffect, useMemo } from "react";
import {
  GoogleMap,
  StandaloneSearchBox,
  useJsApiLoader,
  Polygon,
} from "@react-google-maps/api";
import Pin from "../../../assets/imgs/icons/pin.png";
import { createPortal } from "react-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  clearPickupLocation,
  setPickupLocation,
} from "../../../redux/slices/pickupLocationSlice";

const containerStyle = {
  width: "100%",
  height: "400px",
};

const libraries = ["places", "geometry"];

const PickupMap = ({
  API_KEY,
  setShowPickupMap,
  polygonCoordinates,
  setIsOpen,
}) => {
  const dispatch = useDispatch();
  const pickupLocation = useSelector((state) => state.pickupLocation);

  const pickupRef = useRef(null);
  const pickupMapRef = useRef(null);
  const inputRef = useRef(null);

  const [mapCenter, setMapCenter] = useState({
    lat: 15.273817622105538,
    lng: 76.39305350184958,
  });
  const [outOfBounds, setOutOfBounds] = useState(false);

  const { isLoaded } = useJsApiLoader({
    googleMapsApiKey: API_KEY,
    libraries,
  });

  console.log("polygonCoordinates", polygonCoordinates);

  // ✅ Convert ALL polygon arrays to Google Maps format
  const allPolygonPaths = useMemo(() => {
    if (!Array.isArray(polygonCoordinates) || polygonCoordinates.length === 0) {
      return [];
    }

    return polygonCoordinates.map((polygonArray) =>
      polygonArray.map((coord) => ({
        lat: coord.latitude,
        lng: coord.longitude,
      }))
    );
  }, [polygonCoordinates]);

  // ✅ Create bounds from ALL polygon coordinates
  const bounds = useMemo(() => {
    if (!isLoaded || !window.google?.maps) return null;

    const b = new window.google.maps.LatLngBounds();
    allPolygonPaths.forEach((polygonPath) => {
      polygonPath.forEach((point) => {
        b.extend(new window.google.maps.LatLng(point.lat, point.lng));
      });
    });
    return b;
  }, [isLoaded, allPolygonPaths]);

  // ✅ Function to check if the marker is within ANY of the polygons
  const isWithinPolygon = (lat, lng) => {
    if (!window.google || !window.google.maps || !window.google.maps.geometry) {
      console.error("Google Maps Geometry library is not loaded.");
      return false;
    }

    const point = new window.google.maps.LatLng(lat, lng);

    // Check if point is within ANY polygon
    for (const polygonPath of allPolygonPaths) {
      const polygon = new window.google.maps.Polygon({ paths: polygonPath });
      if (window.google.maps.geometry.poly.containsLocation(point, polygon)) {
        return true; // Point is within this polygon
      }
    }

    return false; // Point is not within any polygon
  };

  // ✅ Reverse Geocode Function
  const reverseGeocode = (lat, lng) => {
    if (!window.google || !window.google.maps?.Geocoder) {
      console.error("Google Maps Geocoder not available");
      return;
    }

    const geocoder = new window.google.maps.Geocoder();
    const location = { lat, lng };

    geocoder.geocode({ location }, (results, status) => {
      if (status === "OK" && results[0]) {
        const address = results[0].formatted_address;
        dispatch(
          setPickupLocation({
            latitude: lat,
            longitude: lng,
            title: address,
            subtext: "",
            place_id: results[0].place_id || "",
          })
        );
        setOutOfBounds(!isWithinPolygon(lat, lng));
      } else {
        console.error("Geocode failed:", status);
      }
    });
  };

  const handlePlaceChange = () => {
    const places = pickupRef.current.getPlaces();
    if (places && places.length > 0) {
      const place = places[0];
      const location = place.geometry.location;
      const lat = location.lat();
      const lng = location.lng();

      if (pickupMapRef.current) {
        pickupMapRef.current.panTo({ lat, lng });
        pickupMapRef.current.setZoom(18);
      }

      setMapCenter({ lat, lng });

      dispatch(
        setPickupLocation({
          latitude: lat,
          longitude: lng,
          title: place.formatted_address || "",
          subtext: "",
          place_id: place.place_id || "",
        })
      );

      setOutOfBounds(!isWithinPolygon(lat, lng));
    }
  };

  const handleMapDragEnd = () => {
    if (pickupMapRef.current) {
      const newCenter = pickupMapRef.current.getCenter();
      const newLat = newCenter.lat();
      const newLng = newCenter.lng();

      setMapCenter({ lat: newLat, lng: newLng });
      reverseGeocode(newLat, newLng);
    }
  };

  const clearSearch = () => {
    dispatch(clearPickupLocation());
  };

  const handleSearchBoxLoad = (ref) => {
    pickupRef.current = ref;

    setTimeout(() => {
      if (inputRef.current) {
        inputRef.current.focus();
      }
    }, 300);
  };

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const lat = position.coords.latitude;
          const lng = position.coords.longitude;

          setMapCenter({ lat, lng });

          if (pickupMapRef.current) {
            pickupMapRef.current.panTo({ lat, lng });
            pickupMapRef.current.setZoom(16);
          }

          reverseGeocode(lat, lng);
        },
        (error) => {
          console.error("Error getting location:", error);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    } else {
      console.warn("Geolocation is not supported by this browser.");
    }
  }, []);

  if (!isLoaded) {
    return <p>Loading map...</p>;
  }

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        zIndex: 9999,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop: "80px",
      }}
    >
      <div className="bg-white p-6 rounded-lg shadow-lg w-11/12 md:w-2/3 relative">
        {/* Search Box */}
        <StandaloneSearchBox
          onLoad={handleSearchBoxLoad}
          onPlacesChanged={handlePlaceChange}
          options={{
            ...(bounds ? { bounds } : {}),
            componentRestrictions: { country: "IN" },
          }}
        >
          <div className="relative">
            <input
              ref={inputRef}
              type="text"
              placeholder="Pickup Location"
              value={pickupLocation?.title || ""}
              onChange={(e) =>
                dispatch(
                  setPickupLocation({
                    ...pickupLocation,
                    title: e.target.value,
                  })
                )
              }
              className="w-full p-2 border rounded mb-3 cursor-pointer pr-10"
            />

            {pickupLocation.title && (
              <button
                onClick={clearSearch}
                className="absolute right-3 top-2 text-gray-500 hover:text-red-500"
              >
                ❌
              </button>
            )}
          </div>
        </StandaloneSearchBox>

        {/* Map */}
        <div className="relative">
          <GoogleMap
            mapContainerStyle={containerStyle}
            center={mapCenter}
            zoom={13}
            onLoad={(map) => (pickupMapRef.current = map)}
            onDragEnd={handleMapDragEnd}
            options={{
              disableDefaultUI: true,
              zoomControl: true,
              mapTypeControl: false,
              fullscreenControl: false,
              streetViewControl: false,
            }}
          >
            {/* ✅ Render ALL Polygons */}
            {allPolygonPaths.map((polygonPath, index) => (
              <Polygon
                key={index}
                paths={polygonPath}
                options={{
                  fillColor: "transparent",
                  fillOpacity: 0.4,
                  strokeColor: "light black",
                  strokeOpacity: 0.5,
                  strokeWeight: 1,
                }}
              />
            ))}
          </GoogleMap>

          {/* Marker */}
          <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2">
            <img src={Pin} alt="Marker" className="w-10 h-10" />
          </div>

          {/* Out of bounds message */}
          {outOfBounds && (
            <div className="absolute top-5 left-1/2 transform -translate-x-1/2 bg-red-500 text-white px-4 py-2 rounded-lg shadow-lg z-10">
              🚫 We are not serving this area.
            </div>
          )}
        </div>

        {/* Buttons */}
        <div className="flex justify-between gap-4 mt-3">
          <button
            className="w-1/2 py-2 bg-white text-red-500 rounded-lg hover:bg-red-200"
            onClick={() => {
              setShowPickupMap(false);
              dispatch(clearPickupLocation());
            }}
          >
            Cancel
          </button>
          <button
            className={`w-1/2 py-2 rounded-lg ${
              outOfBounds
                ? "bg-gray-400 cursor-not-allowed"
                : "bg-black text-white"
            }`}
            onClick={() => {
              setShowPickupMap(false);
              setIsOpen(true);
            }}
            disabled={outOfBounds}
          >
            Confirm
          </button>
        </div>
      </div>
    </div>
  );
};

export default PickupMap;